import { FC } from 'react';
import { Card, Chip, Text } from '@mofid-securities/uikit';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useFindFundByFundCode } from '@/modules/invest/subModules/fund/hooks/useFindFund';

export const Specifications: FC = () => {
  const fundCode = useGetFundCodeFromQuery();

  const { fund } = useFindFundByFundCode(fundCode);

  const hasSpecifications = fund && fund.spec.length > 0;

  return hasSpecifications ? (
    <Card
      className="border-1 border border-gray-solid-primary-enabled"
      padding={16}
      radius="md"
    >
      <Text
        className="mb-2 text-gray-filled-primary-enabled"
        component="h2"
        size="sm"
        weight="demibold"
      >
        ویژگی های صندوق
      </Text>
      <div className="flex flex-wrap gap-2">
        {fund.spec.map((specification, index) => {
          return (
            <Chip
              key={index}
              className="!rounded-[4px] !bg-neutral-filled-primary-enabled !px-2 !py-0 !text-gray-filled-primary-enabled"
              size="sm"
            >
              {specification}
            </Chip>
          );
        })}
      </div>
    </Card>
  ) : null;
};
